import { ColumnProps } from '../ColumnMenu';
import { Fields } from '../ColumnMenu/useColumnMenu';

export const isEqual = (
  columns: ColumnProps[],
  receivedColumns: ColumnProps[],
) => {
  const allColumnsWereFound = columns.every(
    (column: ColumnProps) =>
      receivedColumns.findIndex(
        (receivedColumn: ColumnProps) =>
          column.field === receivedColumn.field &&
          column.show === receivedColumn.show,
      ) > -1,
  );

  if (
    allColumnsWereFound &&
    (columns.length === receivedColumns.length ||
      (columns.length + 1 === receivedColumns.length &&
        receivedColumns.findIndex(
          (receivedColumn: ColumnProps) =>
            receivedColumn.field === Fields.MENUBUTTON,
        )) !== -1)
  ) {
    return true;
  }

  return false;
};
